<ng-container *ngIf="tour$ | async as tour">
  <div class="tour-container">

    <h2>{{ tour.step }}. {{ tour.getTitle() }}</h2>
    <p class="description">
      {{ tour.getDescription() }}
    </p>

    <div class="tour-image" *ngIf="tour.hasImage">
      <img [src]="tour.imageUrl" class="tourImage">
    </div>

    <div class="player" *ngIf="tour.audioUrl">
      <audio controls #audioPlayerElement
             (play)="handleStartPlay($event)"
              (pause)="handlePause($event)"
             (ended)="handleAudioEnded($event)">
        <source [src]="tour.audioUrl" type="audio/mpeg" >
      </audio>
    </div>

<!--    <div class="player" *ngIf="tour.videoUrl">-->
<!--      <video controls>-->
<!--        <source [src]="tour.videoUrl">-->
<!--      </video>-->
<!--    </div>-->

  </div>
</ng-container>
